import { Input, Component, OnChanges, ViewChild } from "@angular/core";
import { Features } from "../../enums/features";

@Component({
    selector: "country-content",
    templateUrl: "./countrycontent.component.html",
    standalone: false
})
export class CountryContentComponent implements OnChanges {
    @Input() item!: any;
    @Input() depth: number = 0;
    @Input() countryCode!: string;
    features = Features;
    public itemVisible: boolean = true;
    public headingClasses!: string;
    @ViewChild("historyModal") historyModal!: any;
    @ViewChild("metadataModal") metadataModal!: any;

    ngOnChanges(): void {
        if (this.item.type === "CategoryItemConfig") {
            this.headingClasses = "d-inline heading-" + this.depth;
        } else {
            this.headingClasses = "d-inline item-heading";
        }
    }

    toggleItem(): void {
        this.itemVisible = !this.itemVisible;
    }

    /*
    * OnShowHistory displays the modal viewer for reviewing historic publishes
    * for an individual data item
    */
    onShowHistory(): void {
        this.historyModal.open();
    }

    /*
    * OnShowSources displays the modal viewer for reviewing sources
    * for an individual data item
    */
    onShowSources(): void {    
        this.metadataModal.open();
    }
}
